export default "__VITE_ASSET__447d79f3__$_?component__"